/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { combineLatest } from 'rxjs';
import { ServiceRequest } from '@src/app/model/serviceRequest';

import { User } from '@src/app/model/user';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { MyRequestService } from '@src/app/modules/crm/my-request.service';
import { MyRequestsComponent } from '@src/app/modules/crm/my-requests/my-requests.component';
import { NewUserRequestDetailComponent } from '@src/app/modules/crm/new-user-request-detail/new-user-request-detail.component';
import { MatTabsModule } from '@angular/material/tabs';
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { PersonalRequestPageNavRoute } from '@src/app/routes/app-router';

@Component({
    selector: 'app-personal-requests',
    standalone: true,
    templateUrl: './personal-requests.component.html',
    styleUrls: ['./personal-requests.component.scss'],
    imports: [MatTabsModule, NewUserRequestDetailComponent, MyRequestsComponent,
        MatExpansionModule, MatIconModule, NgTemplateOutlet,
        RouterLink, MatCardModule]
})
export class PersonalRequestsComponent {
    private currentuserSvc = inject(CurrentUserService);
    private myRequestService = inject(MyRequestService);
    private router = inject(Router);
    public personalNavRoute = PersonalRequestPageNavRoute;


    currentUser: User;
    loaded = false;
    tabIndex = 0;
    isPhone = false;
    selectedRequest: ServiceRequest;
    myRequests: ServiceRequest[] = [];
    openRequests: ServiceRequest[] = [];
    acceptRequests: ServiceRequest[] = [];
    closedRequests: ServiceRequest[] = [];
    currentPanel : 'new'|'open'|'toaccept'|'closed';

    constructor() {
        const activeRoute = inject(ActivatedRoute);
        const isNarrowSvc = inject(IsNarrowService);

        isNarrowSvc.detectVeryNarrow().pipe(takeUntilDestroyed()).subscribe(result => { this.isPhone = result; });
        this.currentuserSvc.getCurrentUser().pipe(takeUntilDestroyed()).subscribe( currentUser => this.currentUser = currentUser);
        combineLatest([
            this.myRequestService.get(false),
            activeRoute.params
        ]).subscribe( ([requests, params]) => {
            this.myRequests = (requests as ServiceRequest[]);
            this.openRequests = this.myRequests.filter( o => o.srStatus === ServiceRequest.srOpen.id);
            this.acceptRequests = this.myRequests.filter(o => o.srStatus === ServiceRequest.srResolved.id);
            this.closedRequests = this.myRequests.filter(o => o.srStatus === ServiceRequest.srAccepted.id);
            if (params.itemId) {
                this.showRequest(this.myRequests.find( o => o.id === params.itemId));
            }
            this.loaded = true;
        })
    }

    canDeactivate() {
        return true;
    }
    
    selectTab($event) {
        this.tabIndex = $event.index;
    }

    showRequest(sr: ServiceRequest) {
        console.log({sr, srs: this.myRequests});
        this.selectedRequest = sr;
        this.tabIndex = 4;
    }

    selectRequest(sr: ServiceRequest) {
        const url = PersonalRequestPageNavRoute.getIdUrl(sr?.id);
        this.router.navigate([url]);
    }
}
